import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { layout } from '../tokens/spacing';

export interface ContentContainerProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

export const ContentContainer: React.FC<ContentContainerProps> = ({ children, style }) => {
  return (
    <View style={styles.wrapper}>
      <View style={[styles.container, style]}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignItems: 'center',
  },
  container: {
    flex: 1,
    width: '100%',
    maxWidth: layout.maxContentWidth,
  },
});

export default ContentContainer;
